import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const KEY = 'al-cookie-consent';

export default function ConsentBanner() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let stored = null;
    try { stored = localStorage.getItem(KEY); } catch (e) { /* private mode */ }
    if (!stored) setVisible(true);
  }, []);

  // Keep demo and preview surfaces clean — no choice stored means trackers stay off anyway.
  if (pathname.startsWith('/demo') || pathname.startsWith('/preview') || pathname === '/booking-desk-prototype') return null;
  if (!visible) return null;

  const choose = (value) => {
    try { localStorage.setItem(KEY, value); } catch (e) { /* private mode */ }
    if (value === 'accepted') window.dispatchEvent(new Event('al-consent-accepted'));
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-3 left-3 right-3 z-[90] rounded-[22px] border border-[#F5F3EF]/16 bg-[#0A1A2F]/95 text-[#F5F3EF] shadow-[0_24px_70px_-28px_rgba(0,0,0,0.9)] backdrop-blur-2xl sm:bottom-5 sm:left-1/2 sm:right-auto sm:w-[min(92vw,980px)] sm:-translate-x-1/2"
    >
      <div className="max-w-[1100px] mx-auto px-5 sm:px-8 py-4 sm:py-5 flex flex-col sm:flex-row sm:items-center gap-4">
        <p className="text-[#F5F3EF]/70 text-sm leading-relaxed flex-1" style={{ fontFamily: "'Poppins', sans-serif" }}>
          We use cookies to understand how visitors use this site and to measure our advertising.
          They are only set if you accept. See our{' '}
          <Link to="/cookie-policy" className="text-[#D4AF37] hover:underline">Cookie Policy</Link>.
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <button
            type="button"
            onClick={() => choose('declined')}
            className="px-4 py-2 text-sm text-[#F5F3EF]/62 hover:text-[#F5F3EF] transition-colors"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Decline
          </button>
          <button
            type="button"
            onClick={() => choose('accepted')}
            className="rounded-full bg-[#F5F3EF] px-5 py-2.5 text-sm font-semibold text-[#0A1A2F] transition-colors hover:bg-[#D4AF37]"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
